import React from 'react'
import { TableConfigSectionFields } from './components/table-section-fields'

export const LayoutConfigTable = (props) => {
  return <TableConfigSectionFields {...props} fieldsProperty="columns" title="Table Columns" />
}
